import { getAppData } from '../utils';
import { ActionFactoryWithPlatformContext } from '../types';
import { SANTA_PRESETS_PANEL_NAME } from '../constants';
import { getCompTypeFromEditorPointer } from '../../../utils/builderServices';

export const presetsActionFactory: ActionFactoryWithPlatformContext = ({
  documentServicesAPI,
  editorPointer,
  manifestServicesAPI,
  hostAPI,
  editorPointerAPI,
}) => ({
  // TODO: add translation key
  actionName: 'presets',
  displayName: 'Presets',
  tags: [],
  execute: () => {
    const compType = getCompTypeFromEditorPointer(
      editorPointer,
      editorPointerAPI,
      documentServicesAPI,
    );

    if (!manifestServicesAPI.isBuilderComponentType(compType)) {
      return;
    }

    const presets = manifestServicesAPI.get.presets(editorPointer);

    const appData = getAppData(compType, documentServicesAPI);

    if (!presets || !appData) {
      return;
    }

    hostAPI.editor.openPanel(
      appData,
      SANTA_PRESETS_PANEL_NAME,
      {
        selectedComponent: [editorPointerAPI.getDocumentPointer(editorPointer)],
        builderPresets: presets,
      },
      true,
    );
  },
});
